<ng-container *ngIf="initialized">
  <form [formGroup]="formGroup" (ngSubmit)="onSave()" novalidate>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Leave Feedback</h5>
      </div>
      <div class="modal-body">
        <div *ngIf="errorMessage" class="alert alert-danger">{{errorMessage}}</div>
        <h6>{{ courseEvent.title }}</h6>
        <div class="form-group">
          <star-rating formControlName="rating"></star-rating>
          <div class="invalid-message">
            <div>Please provide a star rating</div>
          </div>
        </div>

        <div class="form-group">
          <label for="messageTextArea">Feedback:</label>
          <textarea id="messageTextArea" class="form-control" style="transform: translateZ(0px)" formControlName="text"></textarea>
          <div class="invalid-message">
            <div>Feedback text is required</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-sm btn-admin-primary mr-2" type="submit">
              <span>Save</span>
            </button>
            <button class="btn btn-sm btn-outline-dark" (click)="activeModal.dismiss('Cross click')" [promiseBtn]="submitComplete" type="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
